import React, { useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { createSAMLConfiguration } from "reduxSlices/SAMLConfigurationsSlice"
import { useModal } from "hooks"
import { canonicalName, scrubEnteredNameValue } from "utils/SAMLConfigurationHelpers"
import FieldLabel from "shared/FieldLabel"
import Modal, { ModalHeader, DEFAULT_MODAL_STYLE } from "shared/Modal"
import { CustomIconButton, PrimaryButton, TertiaryButton } from "shared/buttons"
import { TextInput } from "shared/inputs"

const FORM_ID = "create-saml-configuration-form"

const AddSAMLConfiguration = () => {
  const dispatch = useDispatch()
  const { modalIsOpen, openModal, closeModal } = useModal()
  const formRef = useRef()
  const nameInputRef = useRef()

  const [rawName, setRawName] = useState("")

  const updateRawName = (value) => {
    setRawName(scrubEnteredNameValue(value))
  }

  const [file, setFile] = useState()

  const changeFile = (event) => {
    setFile(event.target.files[0])
  }

  const name = canonicalName(rawName)
  const canSubmit = name && file

  const reset = () => {
    setRawName("")
    setFile(null)
    formRef.current?.reset()
  }

  const createConfiguration = (event) => {
    event.preventDefault()

    if (!name || !file) return

    dispatch(createSAMLConfiguration(
      {
        idpMetadataFile: file,
        name,
        onSuccess: () => {
          reset()
          closeModal()
        },
      },
    ))
  }

  const cancelCreateSAMLConfiguration = () => {
    reset()
    closeModal()
  }

  return (
    <>
      <CustomIconButton
        className="self-start tertiary-button bg-white"
        icon="add"
        onClick={openModal}
        text="Add SAML Configuration"
      />
      <Modal isOpen={modalIsOpen} onAfterOpen={() => nameInputRef.current?.focus()} style={DEFAULT_MODAL_STYLE}>
        <div className="flex flex-col">
          <ModalHeader closeModal={cancelCreateSAMLConfiguration} heading="New SAML Configuration" />
          <form className="flex flex-col gap-8 w-full" id={FORM_ID} onSubmit={createConfiguration} ref={formRef}>
            <FieldLabel className="w-full !max-w-full" text="Name">
              <TextInput className="bordered-base-input w-full" onChange={updateRawName} ref={nameInputRef} value={rawName} />
            </FieldLabel>
            <FieldLabel className="w-full !max-w-full" text="IDP Metadata File">
              <input
                accept=".xml, text/xml, application/xml"
                className="grow file-input file:bg-white w-full"
                onChange={changeFile}
                type="file"
              />
            </FieldLabel>
            <div className="flex items-center justify-center gap-2">
              <TertiaryButton
                ariaLabel="cancel"
                onClick={cancelCreateSAMLConfiguration}
                text="Cancel"
              />
              <PrimaryButton
                ariaLabel="create SAML configuration"
                disabled={!canSubmit}
                form={FORM_ID}
                text="Submit"
                type="submit"
              />
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

export default AddSAMLConfiguration
